<template>
  <div v-if="item">
    <ul class="rc-toolbar">
      <!-- Permalink -->
      <li v-if="options.display.permalink">
        <rc-btn
          data-bs-toggle="modal"
          data-bs-target="#sharingModalDetail"
          :variant="btnVariant"
          class="rc-btn-icon-text"
        >
          <RcIcon name="link" scale="1.1" />
          <span> {{ $t("common.permalink") }}</span></rc-btn
        >
      </li>

      <!-- add/remove to playlist -->
      <li v-if="options.display.playlists">
        <rc-btn
          :disabled="!item.screeners"
          id="btnAddToPlaylist"
          :variant="btnVariant"
          class="rc-btn-icon-text border-0"
          @click="
            setPlaylistModal({
              item,
              mode: 'add',
              type: 'manual'
            })
          "
          data-bs-target="#createPlaylistModal"
          data-bs-toggle="modal"
        >
          <RcIcon name="playlistAdd" scale="1.25" />
          <span class="visually-hidden">
            {{ $t("catalog.playlist_add_to_only") }}
          </span>
          <span>{{ $t("catalog.playlist") }}</span>
        </rc-btn>
      </li>

      <!-- add bookmark -->
      <template v-if="options.display.bookmarks">
        <li v-if="!getFavorite(item.uid)">
          <RcDebounced
            :variant="btnVariant"
            class="rc-btn-icon-text"
            :promise="addToFavorites.bind(this, item)"
          >
            <RcIcon name="bookmarkAdd" scale="1.2" />
            <span class="visually-hidden">
              {{ $t("catalog.favorites.add_to_only") }}
            </span>
            <span>{{ $t("catalog.favorites.name") }} </span>
          </RcDebounced>
        </li>

        <!-- remove bookmark -->
        <li v-else>
          <rc-btn
            :variant="btnVariant"
            class="rc-btn-icon-text"
            @click="removeFromFavorites(item)"
          >
            <RcIcon name="bookmarkRemove" scale="1.2"></RcIcon>
            <span class="visually-hidden">
              {{ $t("catalog.favorites.remove_only") }}
            </span>
            <span>{{ $t("catalog.favorites.name") }} </span>
          </rc-btn>
        </li>
      </template>

      <!-- segments -->
      <li v-if="options.display.segments">
        <rc-btn
          :disabled="!item.screeners"
          @click="
            setPlaylistModal({
              item,
              mode: 'add',
              type: 'manual'
            })
          "
          :variant="btnVariant"
          class="rc-btn-icon-text border-0"
          data-bs-target="#createSegmentModal"
          data-bs-toggle="modal"
        >
          <RcIcon name="scissor" scale="1.25"></RcIcon>
          <span class="visually-hidden">
            {{ $t("catalog.segment.create_only") }}
          </span>
          <span>{{ $t("catalog.segment.name") }} </span>
        </rc-btn>
      </li>

      <!-- delete alias takedown-->
      <li v-if="options.display.delete">
        <rc-btn
          :variant="btnVariant"
          class="rc-btn-icon-text"
          @click="$emit('delete', item)"
        >
          <RcIcon name="trash" scale="1.1"></RcIcon>
          {{ $t("common.delete") }}
        </rc-btn>
      </li>
    </ul>
    <RcSharingModalDetail
      :helpText="options.sharingHelpText ? options.sharingHelpText : ''"
    />
    <RcCreateSegmentModal
      @init="segmentModal = $event"
      v-if="options.display.segments"
      :permalinkHelpText="
        options.sharingHelpText ? options.sharingHelpText : ''
      "
    />
    <RcCreatePlaylistModal @init="manualModal = $event" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import RcIcon from "@/libvue/components/icons/Base.vue";
import RcDebounced from "@/libvue/components/button/DebouncedButton.vue";
import RcSharingModalDetail from "@/libvue/apps/catalog/playlists/components/SharingModalDetail.vue";
import RcCreatePlaylistModal from "@/libvue/apps/catalog/playlists/components/CreatePlaylistModal.vue";
import RcCreateSegmentModal from "@/libvue/apps/catalog/playlists/components/CreateSegmentModal.vue";

import { favoritesMixin } from "@/libvue/apps/catalog/favorites/mixins";
import { playlistsMixin } from "@/libvue/apps/catalog/playlists/mixins";

export default {
  name: "RcItemDetailToolbar",
  components: {
    RcIcon,
    RcDebounced,
    RcSharingModalDetail,
    RcCreatePlaylistModal,
    RcCreateSegmentModal
  },
  data() {
    return {
      manualModal: "",
      segmentModal: ""
    };
  },
  mixins: [favoritesMixin, playlistsMixin],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Object,
      default: () => {}
    },
    btnVariant: {
      type: String,
      required: false,
      default: "white"
    }
  },
  emits: ["delete"],
  computed: {
    ...mapGetters(["getFavorite"])
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
